/* BKTSQD × NFL 2026 landing section
   Pulls products from the chosen collection via Shopify's public products.json,
   then groups them by team + youth/adult using the product handle:
     {team}-{style}[-youth]-{garment}   e.g. eagles-buckie-youth-hoodie
   New products added to the collection show up automatically. */
(function () {
  var TEAMS = [
    { slug: 'rams',     label: 'Rams',     accent: '#0b53d1' },
    { slug: 'chiefs',   label: 'Chiefs',   accent: '#e31837' },
    { slug: 'patriots', label: 'Patriots', accent: '#1d4f8c' },
    { slug: 'cowboys',  label: 'Cowboys',  accent: '#9aa4ab', text: '#08101c' },
    { slug: 'giants',   label: 'Giants',   accent: '#14428f' },
    { slug: 'eagles',   label: 'Eagles',   accent: '#067c86' },
    { slug: 'bears',    label: 'Bears',    accent: '#e05a1a' }
  ];
  var AGES = [
    { id: 'all', label: 'All' },
    { id: 'youth', label: 'Youth' },
    { id: 'adult', label: 'Adult' }
  ];
  var ORDER = ['camo shorts', 'buckie shorts', 'blitz tee', 'buckie tee', 'blitz hoodie', 'buckie hoodie'];

  function money(cents, fmt) {
    var n = (cents / 100);
    var s = n % 1 === 0 ? n.toFixed(0) : n.toFixed(2);
    return (fmt || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, s);
  }

  function sized(src, w) {
    if (!src) return '';
    return src.replace(/(\.(png|jpe?g|webp))(\?|$)/i, '_' + w + 'x$1$3');
  }

  // "eagles-buckie-youth-hoodie" -> {team, age, style, garment, sortKey}
  function parseHandle(handle) {
    var parts = String(handle).toLowerCase().split('-');
    var team = parts.shift();
    var youth = parts.indexOf('youth');
    var age = youth === -1 ? 'adult' : 'youth';
    if (youth !== -1) parts.splice(youth, 1);
    var style = parts[0] || '';
    var garment = parts[parts.length - 1] || '';
    return { team: team, age: age, style: style, garment: garment, key: style + ' ' + garment };
  }

  function titleFor(product, meta, teamLabel) {
    // Youth leads the title: "Youth Eagles Buckie Hoodie"
    var style = meta.style.charAt(0).toUpperCase() + meta.style.slice(1);
    var garment = meta.garment === 'tee' ? 'Tee' : meta.garment.charAt(0).toUpperCase() + meta.garment.slice(1);
    return (meta.age === 'youth' ? 'Youth ' : '') + teamLabel + ' ' + style + ' ' + garment;
  }

  function init(root) {
    var handle = root.getAttribute('data-collection');
    var fmt = root.getAttribute('data-money-format') || '${{amount}}';
    var teamsEl = root.querySelector('[data-teams]');
    var agesEl = root.querySelector('[data-ages]');
    var gridEl = root.querySelector('[data-grid]');
    var headEl = root.querySelector('[data-headline]');
    if (!handle || !gridEl) return;

    if (root.__nflBooted) return;
    root.__nflBooted = true;

    var state = { team: 'rams', age: 'all', items: [] };
    teamsEl.innerHTML = '';
    agesEl.innerHTML = '';

    TEAMS.forEach(function (t) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nfl__chip';
      b.textContent = t.label;
      b.setAttribute('aria-pressed', String(t.slug === state.team));
      b.addEventListener('click', function () { state.team = t.slug; render(); });
      teamsEl.appendChild(b);
    });

    AGES.forEach(function (a) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'nfl__chip';
      b.textContent = a.label;
      b.setAttribute('aria-pressed', String(a.id === state.age));
      b.addEventListener('click', function () { state.age = a.id; render(); });
      agesEl.appendChild(b);
    });

    // Any link to #nfl-drop (hero CTA, header Shop Now, footer link) resets the
    // filters to the first team + All, then scrolls the shoppable grid into view.
    Array.prototype.forEach.call(root.querySelectorAll('a[href="#nfl-drop"]'), function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        state.team = TEAMS[0].slug;
        state.age = 'all';
        render();
        var drop = document.getElementById('nfl-drop');
        if (!drop) return;
        var y = drop.getBoundingClientRect().top + window.pageYOffset - 12;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });

    function render() {
      var team = TEAMS.filter(function (t) { return t.slug === state.team; })[0] || TEAMS[0];
      root.style.setProperty('--nfl-accent', team.accent);
      root.style.setProperty('--nfl-accent-text', team.text || '#ffffff');

      Array.prototype.forEach.call(teamsEl.children, function (b, i) {
        b.setAttribute('aria-pressed', String(TEAMS[i].slug === state.team));
      });
      Array.prototype.forEach.call(agesEl.children, function (b, i) {
        b.setAttribute('aria-pressed', String(AGES[i].id === state.age));
      });
      if (headEl) {
        var suffix = root.getAttribute('data-headline-suffix') || '';
        headEl.textContent = suffix ? team.label + ' ' + suffix : team.label;
      }

      var rows = state.items.filter(function (p) {
        return p.meta.team === state.team && (state.age === 'all' || p.meta.age === state.age);
      }).sort(function (a, b) {
        if (a.meta.age !== b.meta.age) return a.meta.age === 'youth' ? -1 : 1;
        return ORDER.indexOf(a.meta.key) - ORDER.indexOf(b.meta.key);
      });

      gridEl.innerHTML = '';
      if (!rows.length) {
        var empty = document.createElement('p');
        empty.className = 'nfl__empty';
        empty.textContent = 'No products in this filter yet.';
        gridEl.appendChild(empty);
        return;
      }

      rows.forEach(function (p) {
        var card = document.createElement('article');
        card.className = 'nfl__card';
        var img = p.image ? '<img src="' + sized(p.image, 800) + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy" />' : '';
        card.innerHTML =
          '<a class="nfl__card-media" href="/products/' + p.handle + '">' + img + '</a>' +
          '<div class="nfl__card-body">' +
            '<h3>' + p.title + '</h3>' +
            '<div class="nfl__card-foot">' +
              '<span class="nfl__price">' + money(p.price, fmt) + '</span>' +
              '<a class="nfl__shop" href="/products/' + p.handle + '">Shop</a>' +
            '</div>' +
          '</div>';
        gridEl.appendChild(card);
      });
    }

    function load(page, acc) {
      return fetch('/collections/' + handle + '/products.json?limit=250&page=' + page, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) {
          var list = (d && d.products) || [];
          acc = acc.concat(list);
          return list.length === 250 && page < 5 ? load(page + 1, acc) : acc;
        })
        .catch(function () { return acc; });
    }

    load(1, []).then(function (products) {
      state.items = products.map(function (p) {
        var meta = parseHandle(p.handle);
        var team = TEAMS.filter(function (t) { return t.slug === meta.team; })[0];
        var variant = (p.variants && p.variants[0]) || {};
        return {
          handle: p.handle,
          meta: meta,
          title: team ? titleFor(p, meta, team.label) : p.title,
          price: Math.round(parseFloat(variant.price || 0) * 100),
          image: (p.images && p.images[0] && p.images[0].src) || (p.featured_image || '')
        };
      }).filter(function (p) { return !!TEAMS.filter(function (t) { return t.slug === p.meta.team; })[0]; });
      render();
    });

    render();
  }

  function boot() {
    document.querySelectorAll('[data-nfl-collection]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
